<template>
  <gauge :initial-data="chartData" :override-options="options"></gauge>
</template>

<script>
import Gauge from '../../../charts/Gauge';
import Vue from "vue";
import moment from "moment";

export default {
  name: "FulfillmentGauge",
  methods: {
    fetchFilters(onComplete) {
      return Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        params: {
          a: 'filters',
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params: {
            manufacturer: this.$store.getters.objAuthorize.manufacturer
          }
        }
      }).then((response) => {
        this.loading = false;
        const vendors = [];

        // @TODO is repeated in Landing Section. Clean up!
        const filters = JSON.parse(response.bodyText);

        const filterKeys = Object.keys(filters);

        let FTVendor = false;

        for (let i = 0; i < filterKeys.length; i++) {
          if (filterKeys[i] === 'vendors') {
            let vendors = filters[filterKeys[i]];

            FTVendor = vendors.filter(function (vendor) {
              return vendor.name === 'Finishing Touches';
            });

            break;
          }
        }

        if (FTVendor) {
          vendors.push(FTVendor[0].id);
        }

        if (typeof onComplete === "function") {
          onComplete(vendors);
        }
      });
    },
    fetchData() {
      const instance = this;
      console.log('Fetching Fulfillment count');

      this.loading = true;

      return instance.fetchFilters(function(vendors) {
        return Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
          params: {
            a: 'fulfillment',
            token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
            params: {
              manufacturer: instance.$store.getters.objAuthorize.manufacturer,
              date_from: instance.$store.state.Dashboard.dateRange.from.length !== 0 ? instance.$store.state.Dashboard.dateRange.from : moment().subtract(3, 'months').format('YYYY-MM-DD'), //instance.dateRange.from,
              date_to: instance.$store.state.Dashboard.dateRange.to.length !== 0 ? instance.$store.state.Dashboard.dateRange.to : moment().endOf('day').format('YYYY-MM-DD'), //instance.dateRange.to,
              filters: {vendors: vendors},
              metric: 'count',
              view: instance.$store.state.Dashboard.viewType,
              reporting_increment: instance.$store.state.Dashboard.periodType
            }
          }
        }).then((response) => {
          instance.loading = false;
          const recordSet = JSON.parse(response.bodyText);
          instance.tabTotals = recordSet.totals;
        }).catch((err) => {
          instance.loading = false;
          console.log('An error occurred: ' + err.toString(), err);
        }).finally(() => {
          instance.loading = false;
        });
      });
    }
  },
  data() {
    return {
      tabTotals: {
        total: 0
      },
      options: {
        greenFrom: 0, greenTo: 40,
        yellowFrom: 40, yellowTo: 70,
        redFrom: 70, redTo: 100,
      }
    }
  },
  props: ['bus'],
  computed: {
    chartData: function() {
      let percent = this.tabTotals.nett_total / this.tabTotals.total * 100;

      percent = !isNaN(percent) ? Math.ceil(percent) : 0;

      return [
        ['Label', 'Value'],
        ['Overdue', {v: percent, f: percent + '%'}]
      ]
    }
  },
  created() {
    this.bus.$on('update-data', () => {
      this.fetchData();
    });

    this.fetchData();
  },
  components: {Gauge}
}
</script>

<style scoped>

</style>
